import { React, useState, useEffect, useContext } from 'react';
// import Box from '@iso/components/utility/box';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import CreateTaskHeader from '../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { AppContext } from '../../context/ContextProvider';
import { StickerWidgetWrapper } from '../Widgets/SmallCards/SmallCards.styles';
import { TableWrapper as BlueTableWrapper } from '../UsersCRUD/UsersCRUD.styles';
import Input from '@iso/components/uielements/input';
import searchIcon from '@iso/assets/images/icon/search-icon.svg';
import closeIcon from '@iso/assets/images/icon/close-search-icon.svg';
import { render } from '@testing-library/react';


let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const widgetStyle = {
    display: "flex",
    flexDirection: "column",
    margin: "20px",
    width: "100%",
};

const spanStyle = {
    marginBottom: "20px",
};

export default ({
    columnId,
}) => {

    const { setOpenRightDrawer } = useContext(AppContext);

    const [searchText, setSearchText] = useState("");
    const [initialDataSource] = useState([
        {
            keys: "image",
            // value: "atmosly_service_image",
            value: "$CI_SERVICE_IMAGE",
            description: "If present in the YAML, this variable will be updated with the image built by Atmosly.",
        },
        {
            keys: "namespace",
            // value: "atmosly_service_namespace",
            value: "$CI_SERVICE_NAMESPACE",
            description: "If included, ensures resources are created in the specified namespace during environment creation.",
        },
        {
            keys: "Environment Variables",
            value: "env[]",
            description: "Should be initialized with ‘[]’ in the YAML to inject the environment variables defined above.",
        },
    ]);
    const [dataSource, setDataSource] = useState(initialDataSource);

    useEffect(() => {
        if (searchText) {
            let filtered = initialDataSource.filter((item) => {
                return item.keys && item.keys.toLowerCase().includes(searchText.toLowerCase());
            });
            setDataSource(filtered);
        } else {
            setDataSource(initialDataSource);
        }
    }, [searchText]);

    const handelSearchBox = (e) => {
        setSearchText(e.target.value);
    }

    const handelDeleteSearchBox = (e) => {
        setSearchText("");
    }

    const handleCancel = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    };

    const columns = [
        {
            title: 'Keys',
            dataIndex: 'keys',
            key: 'keys',
            width: '220px'
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            width: '220px',
            render: (text) => {
                return <span style={{ color: "#4D99EF" }}>{text}</span>;
            }
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: '220px'
        },
    ];


    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent={columnId} onCancel={handleCancel} />

            <div style={{ marginTop: "84px", width: "100%" }} />

            <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                <span style={{ ...spanStyle, color: "#4D99EF" }}>Advance YAML</span>
                <span  style={{ ...spanStyle }}>The <span style={{color: "#4D99EF"}}>$CI_SERVICE_IMAGE</span> variable, if present in the YAML, will be updated with the image built by <span style={{color: "#4D99EF"}}>Atmosly.</span></span>
                <span  style={{ ...spanStyle }}>Additionally, the <span style={{color: "#4D99EF"}}>env</span> variable should be initialized with <span style={{color: "#4D99EF"}}>‘[]’</span> in the YAML to inject the environment variables defined above.</span>

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "20px", marginTop: "20px" }}>
                    <Input
                        name="search"
                        className="env-var-search"
                        value={searchText}
                        color="#F3F3F3"
                        onChange={handelSearchBox}
                        placeholder="Search keys…"
                        prefix={<img src={searchIcon} alt="search" style={{}} />}
                        suffix={searchText && <img src={closeIcon} alt="search" style={{ cursor: "pointer" }} onClick={handelDeleteSearchBox} />}
                        style={{ width: "100%", height: "43px", borderRadius: "8px" }}
                    />
                </div>

                <BlueTableWrapper
                    rowKey="key"
                    columns={columns}
                    bordered={true}
                    dataSource={dataSource}
                    rowClassName={(record, idx) => {
                        if (idx % 2 === 0) {
                            return 'even-rows';
                        }
                        else {
                            return 'odd-rows';
                        }
                    }}
                    loading={false}
                    className="isoSimpleTable"
                    pagination={false}
                    style={{ width: "100%" }}
                />
            </StickerWidgetWrapper>
        </LayoutWrapper>
    );
}
// };